import activities2020 from './2020/index';

export default {
  path: '/activities',
  component: resolve => require(['@/components/common/ViewTemplate'], resolve),
  children: [
    activities2020,
  ],
};



// WEBPACK FOOTER //
// ./src/router/modules/activities/index.js